import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Y from '../../y18n'
import * as productActions from '../../store/products'
import Styles from '../styles'

const mapStateToProps = state => ({
  products: state.products
})

const mapDispatchToProps = dispatch => ({
  productActions: bindActionCreators(productActions, dispatch)
})

class ProductsDropdown extends Component {
  componentDidMount () {
    if (this.props.country) {
      this.props.productActions.getProductsForCountry(this.props.country)
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.country && prevProps.country !== this.props.country) {
      this.props.productActions.getProductsForCountry(this.props.country)
    }
  }

  render () {
    const { products, value, handleChange, classes, alwaysShowDefaultOption } = this.props

    return (
      <TextField
        select
        label={Y`Suggested refill product`}
        value={value}
        onChange={handleChange}
        SelectProps={{
          native: true
        }}
        InputProps={{
          disableUnderline: true,
          classes: {
            root: classes.root,
            input: classes.input
          }
        }}
        InputLabelProps={{
          shrink: true,
          className: classes.formLabel
        }}
        margin='normal'
        fullWidth
      >
        {value === '' || alwaysShowDefaultOption ? (
          <option key={'default'} value={''}>
            {Y`Choose a product`}
          </option>
        ) : (
          ''
        )}
        {products.productsForCountry &&
          products.productsForCountry.length > 0 &&
          products.productsForCountry.map(product => (
            <option key={product.id} value={product.id}>
              {product.name}
            </option>
          ))}
      </TextField>
    )
  }
}

ProductsDropdown = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductsDropdown)
export default withStyles(Styles)(ProductsDropdown)



// WEBPACK FOOTER //
// ./src/common/dropdowns/products-dropdown.js